const Else = ({ conditional, children }) => !conditional && (children || null);

export default Else;
